"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enums_1 = require("../enums");

var utils_1 = require("../utils");

var SceneConverter_1 = require("./SceneConverter");

var StringVariableConverter_1 = require("./StringVariableConverter");

var StyleConverter_1 = require("./StyleConverter");

var SubtitleOptionsConverter_1 = require("./SubtitleOptionsConverter");

var ControlOptionsConverter_1 = require("./ControlOptionsConverter");

var TemplateConverter =
/** @class */
function () {
  function TemplateConverter() {}

  TemplateConverter.prototype.fromMessage = function (message) {
    var object = {
      scenes: utils_1.withDefault(message.scenes, []).map(function (x) {
        return SceneConverter_1.sceneConverter.fromMessage(x);
      }),
      content: utils_1.withDefault(message.content, ""),
      autoPlay: utils_1.withDefault(message.autoPlay, false),
      defaultSceneId: StringVariableConverter_1.stringVariableConverter.fromMessage(utils_1.withDefault(message.defaultSceneId, utils_1.withDefault(message.scenes[0] && message.scenes[0].id, ""))),
      subtitleOptions: SubtitleOptionsConverter_1.subtitleOptionsConverter.fromMessage(utils_1.withDefault(message.subtitleOptions, {})),
      controlOptions: ControlOptionsConverter_1.controlOptionsConverter.fromMessage(utils_1.withDefault(message.controlOptions, {}))
    };
    if (utils_1.hasValue(message.poster)) object.poster = StringVariableConverter_1.stringVariableConverter.fromMessage(message.poster);
    if (utils_1.hasValue(message.style)) object.style = StyleConverter_1.styleConverter.fromMessage(message.style);
    return object;
  };

  TemplateConverter.prototype.toMessage = function (object) {
    var message = {
      scenes: object.scenes.map(function (x) {
        return SceneConverter_1.sceneConverter.toMessage(x);
      }),
      content: object.content,
      autoPlay: object.autoPlay,
      subtitleOptions: SubtitleOptionsConverter_1.subtitleOptionsConverter.toMessage(object.subtitleOptions),
      controlOptions: ControlOptionsConverter_1.controlOptionsConverter.toMessage(object.controlOptions)
    };
    if (utils_1.hasValue(object.poster)) message.poster = StringVariableConverter_1.stringVariableConverter.toMessage(object.poster);
    if (utils_1.hasValue(object.style)) message.style = StyleConverter_1.styleConverter.toMessage(object.style);
    if (!(object.defaultSceneId.type === enums_1.StringVariableType.Constant && object.defaultSceneId.value === (object.scenes[0] && object.scenes[0].id))) message.defaultSceneId = StringVariableConverter_1.stringVariableConverter.toMessage(object.defaultSceneId);
    return object;
  };

  return TemplateConverter;
}();

exports.TemplateConverter = TemplateConverter;
exports.templateConverter = new TemplateConverter();